import { default as ValueDisplay, ValueDisplayProps } from './ValueDisplay'
import { WiThermometer, WiHumidity, WiBarometer, WiStrongWind, WiDaySunny } from "react-icons/wi";
import { useGetMeasurmentColor } from '../../../hooks/useGetMeasurmentColor';
import React from 'react';


export type ValueDisplayIconProps = {
    schema: string,
} & ValueDisplayProps;

const ValueDisplayIcon = (props: ValueDisplayIconProps) => {
    const [color] = useGetMeasurmentColor(props.dimension,props.schema);
    const isNormalPercentSensor = props.schema === 'AutomationApps.Devices.Sensors.SensorAnalog' && props.dimension === '%';
    const MyIcon = isNormalPercentSensor ? undefined : (props.dimension ? icons[props.dimension] : undefined);

    if (!MyIcon)
        return (<ValueDisplay {...props} icon={undefined}></ValueDisplay>)
        
    return (<ValueDisplay {...props} icon={<MyIcon color={color} size='25px' />}></ValueDisplay>)
}
export default React.memo(ValueDisplayIcon);

interface IDictionary {
    [index: string]: any;
}

const icons = {
    '°C': WiThermometer,
    '°F': WiThermometer,
    '°K': WiThermometer,
    '%rF': WiHumidity,
    '%': WiHumidity,
    'Pa': WiBarometer,
    'pa': WiBarometer,
    'bar': WiBarometer,
    'm³/h': WiStrongWind,
    'lux': WiDaySunny,
    'lx': WiDaySunny,
    'km/h': WiStrongWind,
    'm/s': WiStrongWind,
    'default': undefined,
} as IDictionary
